export { default } from "./appointmentDetails";
